<template>
<div class="row">
  <select class="margin-select" v-model="versao">
    <option value="V1"> API V1</option>
    <option value="V2"> API V2</option>
  </select>
  <div class="col-sm-12">
    <table class="Table table -cosy">
      <tbody v-for="(servicos, categoria) in servicosSelecionados" :key="categoria">
        <tr>
          <td colspan="4">
            <h4 style="margin: 25px 0 10px 0">{{ categoria }}</h4>
          </td>
        </tr>
        <tr style="height: 100px" v-for="servico in servicos">
          <td>{{ servico.nome }}</td>
          <td>{{ servico.descricao }}</td>
          <td style="white-space: nowrap">

            <span v-if="servico.preco_usuario.faixas">
                  0+: R$ {{ (servico.preco_usuario.valor * 0.01).toLocaleString('pt-BR', {minimumFractionDigits: 2})}}
                  <div v-for="(valor, faixa) in servico.preco_usuario.faixas" :key="faixa" class="mb-1">
                    {{ faixa }}+: R$ {{ (valor * 0.01).toLocaleString('pt-BR', {minimumFractionDigits: 2}) }}
                  </div>
                </span>
            <span v-else>
            {{ categoria === 'Monitoramento no site do Tribunal' || categoria === 'Monitoramento de Diários Oficiais' || categoria === 'Monitoramentos'
              ? (servico.preco_usuario.valor / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })+" / mês"
              : (servico.preco_usuario.valor / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
              }} <span v-if="['CAPA_PROCESSO','PROCESSO_MOVIMENTACOES','ATUALIZACAO_PROCESSO', 'PROCESSO_DOCUMENTOS_PUBLICOS', 'ATUALIZACAO_PROCESSO_DOCUMENTOS_PUBLICOS', 'ATUALIZACAO_PROCESSO_AUTOS', 'PROCESSO_AUTOS'].includes(servico.identificador)">*</span>
            </span>

            <template v-if="servico.preco_usuario.quantidadeIsenta">
              <small>até {{ servico.preco_usuario.tamanhoFaixa }} {{ servico.identificador == 'MONITORAMENTO' ? 'resultados/mês' : 'itens' }}</small>
              <br>
              <small style="white-space: nowrap">
                + {{ (servico.preco_usuario.valorExtra / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                a cada {{ servico.preco_usuario.tamanhoFaixa }}
              </small>
            </template>
          </td>
          <td>
            <a class="link -color" :href="servico.link_documentacao" target="_blank">
              docs
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <p><small>* Para informações detalhadas sobre a cobrança de acesso a processos, consulte nosso artigo: <a class="link -color" href="https://suporte-api.escavador.com/hc/pt-br/articles/27682373298331-Como-funciona-a-cobran%C3%A7a-do-processo-na-v2" target="_blank">Como funciona a cobrança do processo na v2</a></small></p>
  </div>
</div>
</template>

<script>
export default {
  props: {
    servicosV1: {
      type: Object,
      default() {
        return [];
      }
    },
    servicosV2: {
      type: Object,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      versao: 'V2',
    }
  },
  computed: {
    servicosSelecionados() {
      return this.versao === 'V2' ? this.servicosV2 : this.servicosV1;
    }
  },
}
</script>
<style scoped lang="stylus">
.margin-select
  margin-left 15px
  margin-top 20px
</style>
